// extracted by mini-css-extract-plugin
export default {"container":"FAQs_container__UWv1p"};